import Styled from 'styled-components';

const DividerStyle = Styled.hr`
  border: 1px solid #E5E5E5;
  margin: 15px 0;
`;

export default DividerStyle;
export { DividerStyle };
